import texts from './texts_i18n.js'

export default {
  app: {
    activeTab: 'deliv',
    appState:0,
    back: false,
    backPage: '',
    config: {},
    language: 'pt-br',
    plate: '',    
    texts: texts,
    route: '',
    version: 'V0-1-084'
  },
  deliveries: {
    delivState:0,
    deliveries: [],
    key: ''
  },
  orders: {
    ordersDeliv: 0,
    orderData: {},
    ordersState:0,
    orders: [],
  },
  msgDialog: {
    dialogState: 0,
    dialogBody: '',
    dialogBtn: 0,
    dialogBtn1: () => {},
    dialogBtn1Txt: '',
    dialogBtn2: () => {},
    dialogBtn2Txt: '',
    dialogHeader: '',
    dialogOpen: false,
    dialogPayload: []
  },
  login: {
    loginState:0,
    pswd:'',
    user:''
  },
  profile: {
    profileState:0,
    user: '',
    branch: ''
  },
  sensors: {
    sensorsState:0,
    sensors: []
  }
}


// WEBPACK FOOTER //
// ./src/store/initialState.js